<template>
  <v-textarea
    :value="value"
    @input="$emit('input', $event)"
    :rules="rules"
    :readonly="readonly"
    rounded
    filled
    dense
    color="secondary"
    background-color="primary"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:label>
      <slot name="label">{{ label }}</slot>
    </template>
  </v-textarea>
</template>

<script>
export default {
  name: 'BaseTextArea',
  props: {
    label: { type: String, default: '' },
    value: [String, Number],
    rules: Array,
    readonly: Boolean,
  },
}
</script>
